window.handleSynchronizerBar = function (config) {
    class SynchronizerBarProgress {
        constructor(element) {
            this.element = $(element);
            this.progressBar = this.element.find('.progress-bar');
            this.progressText = this.element.find('.data_progress_string');
            this.progressMessage = this.element.find('.data_progress_message');
        }

        get currentValue() {
            return parseInt(this.progressBar.attr('aria-valuenow'), 10);
        }

        update(data) {
            const { percentage, message } = data;
            this.progressBar.css('width', `${percentage ?? 0}%`);
            this.progressBar.attr('aria-valuenow', percentage ?? 0);
            this.progressText.text(`${percentage ?? 0}%`);
            this.progressMessage.html(`${message ?? ''}`)
        }
    }

    class SynchronizerBar {
        constructor(config) {
            this.element = $(config.element);
            this.progressBar = new SynchronizerBarProgress(config.element);
            this.endpointUrl = this.element.data('endpoint-url');
            this.initialize();
        }

        initialize() {
            if (!this.element.data('in-synchronize')) {
                console.log('Sincronização não permitida para este elemento.');
                return;
            }
            if (!this.endpointUrl) {
                console.log('Endpoint URL não encontrado.');
                return;
            }
            if (this.progressBar.currentValue >= 100) {
                console.log('Sincronização concluída. Nenhuma nova requisição será enviada.');
                return;
            }
            this.start();
        }

        start() {
            const url = `${this.endpointUrl}`;
            $.ajax({
                url: url,
                type: 'GET',
                global: false,
                dataType: 'json',
                success: (data) => this.progressBar.update(data),
                error: (xhr, status, error) => console.error('Erro ao enviar os dados:', error)
            });
        }
    }

    new SynchronizerBar(config);
};
